<section class="profile-menu">
  <!-- user profile -->
  <div class="profile-menu__header">
    <div class="header-user">
      <img
        [ngSrc]="
          user?.profile_image?.cropped_url?.toLowerCase() ||
            user?.profile_image?.url
            | imageSource: false : 'sm' : 'assets/images/no-profile-image.png'
        "
        width="56"
        height="56"
        class="header-user__img" />
      <div class="header-user__info">
        @if (user?.username) {
          <h4 class="info-name">
            <pwj-text-summarizer [text]="user.username" [limitLength]="14">
            </pwj-text-summarizer>
          </h4>
        }
        <p class="info-role">
          {{ user?.job_position | translateData }}
        </p>
      </div>
    </div>
    <!-- logout btn -->
    <button (click)="logout()">
      <i class="menu-item-icon iconsax" icon-name="logout-2"></i>
    </button>
  </div>

  <!-- profile menu list -->
  <ul class="profile-menu__list">
    <!-- internal routes -->
    @for (item of menuInternalRoutes; track $index) {
      <li class="menu-item internal-route" (click)="onClickProfileMenuItems()">
        <a
          class="menu-item__link"
          [routerLink]="item.route"
          [ngClass]="{
            '[&>*]:!text-primary-dark':
              item.route && currentRoute?.includes(item.route),
          }">
          <i class="menu-item-icon iconsax" [attr.icon-name]="item.icon"></i>
          <p class="menu-item-name">{{ item.name | translate }}</p>
        </a>
      </li>
    }

    <!-- external routes -->
    <li class="menu-item">
      <a class="menu-item__link">
        <span class="menu-item__name">
          {{ 'global.panel' | translate }}
        </span>
      </a>
    </li>

    @for (item of menuExternalRoutes; track $index) {
      <li class="menu-item external-route" (click)="onClickProfileMenuItems()">
        <a class="menu-item__link" [href]="item.href">
          <i class="menu-item-icon iconsax" [attr.icon-name]="item.icon"></i>
          <p class="menu-item-name">{{ item.name | translate }}</p>
        </a>
      </li>
    }
  </ul>
</section>
